import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { loadBio, BioData } from '../utils/bioLoader';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BioPage: React.FC = () => {
  const { memberName } = useParams<{ memberName: string }>();
  const [bio, setBio] = useState<BioData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Scroll to top when component mounts or memberName changes
    window.scrollTo(0, 0);
    
    if (memberName) {
      loadBio(memberName)
        .then(bioData => {
          setBio(bioData);
          setLoading(false);
          if (bioData) {
            document.title = `${bioData.name} - Ocean BioMetrics`;
          }
        })
        .catch(() => {
          setLoading(false);
        });
    }

    // Fallback timeout to show content even if bio loading fails
    const timeout = setTimeout(() => {
      if (loading) {
        setLoading(false);
      }
    }, 2000);

    return () => clearTimeout(timeout);
  }, [memberName, loading]);


  if (loading) {
    return (
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <main className="flex-grow-1">
          <section id="bio" className="py-5" style={{ marginTop: '120px' }}>
            <div className="container">
              <div className="row">
                <div className="col-md-4 text-center">
                  <div 
                    className="circular-headshot-large mb-4" 
                    style={{ 
                      backgroundColor: '#333', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      color: '#fff'
                    }}
                  >
                    Loading...
                  </div>
                  <h2 className="display-5">Loading...</h2>
                </div>
                <div className="col-md-8">
                  <div className="lead">Loading bio content...</div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    );
  }

  const displayBio = bio || {
    name: 'Team Member',
    image: '/images/team/default.jpg',
    title: '',
    content: 'Bio information is currently unavailable.'
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <main className="flex-grow-1">
        <section id="bio" className="py-5" style={{ marginTop: '120px' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-4 text-center">
                <img 
                  src={displayBio.image} 
                  className="circular-headshot-large mb-4" 
                  alt={displayBio.name}
                  style={{ 
                    opacity: 1, 
                    transition: 'opacity 0.3s ease' 
                  }}
                />
                <h2
                  className="display-5"
                  style={{
                    opacity: 1,
                    transition: 'opacity 0.3s ease 0.1s',
                    whiteSpace: 'pre-line'
                  }}
                >
                  {displayBio.name}
                </h2>
                {displayBio.title && (
                  <p
                    className="fs-5"
                    style={{
                      opacity: 1,
                      transition: 'opacity 0.3s ease 0.2s',
                      whiteSpace: 'pre-line'
                    }}
                  >
                    <em>{displayBio.title}</em>
                  </p>
                )}
              </div>
              <div className="col-md-8">
                <div 
                  className="lead bio-content" 
                  style={{ 
                    opacity: 1, 
                    transition: 'opacity 0.3s ease 0.3s'
                  }}
                  dangerouslySetInnerHTML={{ __html: displayBio.content }}
                />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BioPage;